"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldDataTableCoreInputs = void 0;
const common_params_1 = require("./common.params");
const header_params_1 = require("./header.params");
/**
 * Represents the inputs for the EmeraldDataTableCore component.
 * @template T - The type of data in each row of the table.
 */
class EmeraldDataTableCoreInputs {
    constructor() {
        /**
         * The unique identifier for the data table.
         */
        this.id = `emerald-data-table-${Math.floor(Math.random() * 10000)}`;
        /**
         * The header parameters for the data table.
         */
        this.headerParams = new header_params_1.HeaderParamsCore();
        /**
         * The column definitions of the data table.
         */
        this.columnDefs = [];
        /**
         * whether to enable multi column sort
         */
        this.multiColumnSort = false;
        /**
         * The data rows of the data table.
         */
        this.rowData = [];
        /**
         * whether to enable columns resize
         */
        this.allowResizeColumns = false;
        /**
         * The table view mode.
         */
        this.viewMode = common_params_1.TableViewMode.HorizontalLines;
        /**
         * The row height in rem.
         * Default is 3.25 rem.
         */
        this.rowHeightInRem = 3.25;
        /**
         * whether to show global columns menu
         */
        this.showColumnsMenu = false;
        /**
         * whether to enable inline editing
         */
        this.editable = false;
        /**
         * whether to enable expandable rows
         */
        this.enableExpandableRows = false;
        /**
         * The minimum height of an expandable row in pixels.
         */
        this.expandableRowMinHeight = 200;
    }
}
exports.EmeraldDataTableCoreInputs = EmeraldDataTableCoreInputs;
//# sourceMappingURL=data-table.inputs.js.map